/**
 * FIGlet風ASCIIロゴ生成モジュール
 * oh-my-logoスタイルでJOIN USを表示
 */

// FIGlet "block" style character definitions (6 rows each)
const FILLED = {
  ' ': ['   ','   ','   ','   ','   ','   '],
  'J': ['     ██╗','     ██║','     ██║','██   ██║','╚█████╔╝',' ╚════╝ '],
  'O': [' ██████╗ ','██╔═══██╗','██║   ██║','██║   ██║','╚██████╔╝',' ╚═════╝ '],
  'I': ['██╗','██║','██║','██║','██║','╚═╝'],
  'N': ['███╗   ██╗','████╗  ██║','██╔██╗ ██║','██║╚██╗██║','██║ ╚████║','╚═╝  ╚═══╝'],
  'U': ['██╗   ██╗','██║   ██║','██║   ██║','██║   ██║','╚██████╔╝',' ╚═════╝ '],
  'S': ['███████╗','██╔════╝','███████╗','╚════██║','███████║','╚══════╝'],
};

// Gradient colors (cyan/teal theme matching the site)
const COLORS = ['#33e9a6', '#28d7d6', '#24c5ff'];

/**
 * Parse hex color to RGB array
 */
function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}

/**
 * Linear interpolation
 */
function lerp(a, b, t) {
  return a + (b - a) * t;
}

/**
 * Interpolate between gradient colors
 */
function interpolateColor(colors, t) {
  const n = colors.length - 1;
  const seg = Math.min(Math.floor(t * n), n - 1);
  const segT = t * n - seg;
  const c1 = hexToRgb(colors[seg]);
  const c2 = hexToRgb(colors[seg + 1]);
  const r = Math.round(lerp(c1[0], c2[0], segT));
  const g = Math.round(lerp(c1[1], c2[1], segT));
  const b = Math.round(lerp(c1[2], c2[2], segT));
  return `rgb(${r},${g},${b})`;
}

/**
 * Build colorized FIGlet logo HTML for a single word
 */
function buildFigletWord(text, colors = COLORS, totalRows = 6) {
  const ROWS = 6;
  const chars = text.toUpperCase().split('');
  
  // Build grid: each row is a string
  const grid = Array.from({ length: ROWS }, () => '');
  
  for (const ch of chars) {
    const glyph = FILLED[ch] || FILLED[' '];
    for (let r = 0; r < ROWS; r++) {
      grid[r] += (glyph[r] || '') + ' ';
    }
  }
  
  // Build HTML with colorized spans
  let html = '';
  
  for (let r = 0; r < ROWS; r++) {
    const row = grid[r];
    for (let c = 0; c < row.length; c++) {
      const char = row[c];
      // Vertical gradient: t based on row position within total rows
      const t = r / (totalRows - 1);
      const color = interpolateColor(colors, Math.max(0, Math.min(1, t)));
      html += `<span style="color:${color}">${char}</span>`;
    }
    html += '\n';
  }
  
  return html;
}

/**
 * Build colorized FIGlet logo HTML
 * @param {string[]} lines - Array of words (each word on separate line)
 */
function buildFigletLogo(lines, colors = COLORS) {
  const ROWS = 6;
  const totalRows = lines.length * ROWS;
  let html = '';
  
  lines.forEach((word, lineIndex) => {
    const chars = word.toUpperCase().split('');
    const grid = Array.from({ length: ROWS }, () => '');
    
    for (const ch of chars) {
      const glyph = FILLED[ch] || FILLED[' '];
      for (let r = 0; r < ROWS; r++) {
        grid[r] += (glyph[r] || '') + ' ';
      }
    }
    
    for (let r = 0; r < ROWS; r++) {
      const row = grid[r];
      for (let c = 0; c < row.length; c++) {
        const char = row[c];
        // Vertical gradient across all lines
        const globalRow = lineIndex * ROWS + r;
        const t = globalRow / (totalRows - 1);
        const color = interpolateColor(colors, Math.max(0, Math.min(1, t)));
        html += `<span style="color:${color}">${char}</span>`;
      }
      html += '\n';
    }
  });
  
  return html;
}

// Breakpoint for mobile/desktop
const TAB_BREAKPOINT = 768;

/**
 * Render logo based on viewport width
 */
function renderLogo(container) {
  const isMobile = window.innerWidth < TAB_BREAKPOINT;
  const lines = isMobile ? ['JOIN', 'US'] : ['JOIN US'];
  container.innerHTML = buildFigletLogo(lines);
}

/**
 * Initialize FIGlet logo in footerCta section
 */
export function initFigletLogo() {
  const container = document.getElementById('figlet-logo');
  if (!container) return;
  
  // Initial render
  renderLogo(container);
  
  // Re-render on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => renderLogo(container), 150);
  });
}
